import { render, staticRenderFns } from "./PerTrain.vue?vue&type=template&id=2e91290e&scoped=true&"
import script from "./PerTrain.vue?vue&type=script&lang=js&"
export * from "./PerTrain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e91290e",
  null
  
)

export default component.exports